import ReactEDSWrapper from '../../../utils/react-eds-wrapper';
import { Button, Input, Table, Row, Cell, Pagination } from '@dsi/react-eds';
import styles from '../swgw-scanning/ProductNumberTable.module.css';

interface ImagePathTagTableProps {
  imagePathTags: { image_path: string; tag: string }[];
  page: number;
  pageSize: string;
  numPages: number;
  filterPath: string;
  filterTag: string;
  sortAttr: 'image_path' | 'tag' | undefined;
  sortOrder: 'asc' | 'desc' | undefined;
  onEdit: (idx: number) => void;
  onDelete: (idx: number) => void;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: string) => void;
  onSort: (order: 'asc' | 'desc', attr: 'image_path' | 'tag') => void;
  onFilterPath: (val: string) => void;
  onFilterTag: (val: string) => void;
}

const ImagePathTagTable: React.FC<ImagePathTagTableProps> = ({
  imagePathTags,
  page,
  pageSize,
  numPages,
  filterPath,
  filterTag,
  sortAttr,
  sortOrder,
  onEdit,
  onDelete,
  onPageChange,
  onPageSizeChange,
  onSort,
  onFilterPath,
  onFilterTag,
}) => {
  const columns = [
    {
      title: 'Image Path',
      attribute: 'image_path',
      sortable: true,
      width: '50%',
      sortOrder: sortAttr === 'image_path' ? sortOrder : undefined,
    },
    {
      title: 'Tag',
      attribute: 'tag',
      sortable: true,
      sortOrder: sortAttr === 'tag' ? sortOrder : undefined,
    },
    { title: '', attribute: 'actions' },
  ];

  return (
    <div className={styles.productNumberListContainer}>
      <div className={styles.settingsTitle}>Image Path & Tag List</div>
      <div className={styles.productNumberListInfo}>
        {imagePathTags.length > 0 ? `${(page - 1) * parseInt(pageSize, 10) + 1} - ${Math.min(page * parseInt(pageSize, 10), imagePathTags.length)} of ${imagePathTags.length} items` : null}
      </div>
      <ReactEDSWrapper
        component={Table}
        columns={columns}
        filters={
          <ReactEDSWrapper component={Row}>
            <ReactEDSWrapper component={Cell}>
              <ReactEDSWrapper
                component={Input}
                className={styles.searchField}
                placeholder="Filter"
                type="search"
                value={filterPath}
                onChange={e => {
                  const value = (e.target as HTMLInputElement).value;
                  onFilterPath(value);
                }}
              />
            </ReactEDSWrapper>
            <ReactEDSWrapper component={Cell}>
              <ReactEDSWrapper
                component={Input}
                className={styles.searchField}
                placeholder="Filter"
                type="search"
                value={filterTag}
                onChange={e => {
                  const value = (e.target as HTMLInputElement).value;
                  onFilterTag(value);
                }}
              />
            </ReactEDSWrapper>
            <ReactEDSWrapper component={Cell} />
          </ReactEDSWrapper>
        }
        showFilters
        sortable
        onSort={(order: 'asc' | 'desc', attr: 'image_path' | 'tag') => {
          onSort(order, attr);
        }}
      >
        {imagePathTags.map((item, idx) => (
          <ReactEDSWrapper component={Row} key={idx}>
            <ReactEDSWrapper component={Cell}>{item.image_path}</ReactEDSWrapper>
            <ReactEDSWrapper component={Cell}>{item.tag}</ReactEDSWrapper>
            <ReactEDSWrapper component={Cell} className={styles.actionsCell}>
              <ReactEDSWrapper
                component={Button}
                className={`btn icon-btn ${styles.iconBtn}`}
                aria-label="Edit"
                onClick={() => onEdit(idx)}
              >
                <i className="icon icon-edit"></i>
              </ReactEDSWrapper>
              <ReactEDSWrapper
                component={Button}
                className={`btn icon-btn ${styles.iconBtn}`}
                aria-label="Delete"
                onClick={() => onDelete(idx)}
              >
                <i className="icon icon-trashcan"></i>
              </ReactEDSWrapper>
            </ReactEDSWrapper>
          </ReactEDSWrapper>
        ))}
      </ReactEDSWrapper>
      <ReactEDSWrapper
        component={Pagination}
        numPages={numPages}
        selectedPage={page}
        onPaginationChangePage={onPageChange}
        optionsList={[
          { value: '10', label: '10', active: pageSize === '10' },
          { value: '20', label: '20', active: pageSize === '20' },
          { value: '30', label: '30', active: pageSize === '30' },
        ]}
        onPaginationChangeSelect={onPageSizeChange}
        withActions
      />
    </div>
  );
};

export default ImagePathTagTable;
